import { useEffect } from 'react';
import { create } from 'zustand';

interface UiState {
  /** Count of currently-mounted blocking modals/dialogs. See useModalRegistration. */
  openModalCount: number;
  pushModal: () => void;
  popModal: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  openModalCount: 0,
  pushModal: () => set((s) => ({ openModalCount: s.openModalCount + 1 })),
  popModal: () => set((s) => ({ openModalCount: Math.max(0, s.openModalCount - 1) })),
}));

/**
 * Registers a mounted modal/dialog in the shared open-modal count for as long
 * as the calling component is mounted. Anything that wants to avoid stacking
 * on top of other UI (e.g. the nudge timer) can read `openModalCount` instead
 * of maintaining its own list of every modal in the app.
 */
export function useModalRegistration(): void {
  useEffect(() => {
    useUiStore.getState().pushModal();
    return () => useUiStore.getState().popModal();
  }, []);
}
